class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const accordionEl = this.querySelector(".m-footer--accordion");
    const stickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (accordionEl) {
      // footer.js is idle-loaded — window "load" has usually already fired.
      // Accordion onload:true would never run setContentHeight, so default-open
      // panels stay opacity:0 / max-height:0 until toggled once.
      if (MinimogTheme.config.mqlMobile) {
        this.initMobileAccordion(accordionEl);
      }
      document.addEventListener("matchMobile", () => {
        this.initMobileAccordion(accordionEl);
      });
    }

    if (stickyBar) {
      document.documentElement.style.setProperty(
        "--mobile-sticky-bar-height",
        `${stickyBar.offsetHeight}px`
      );
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty(
          "--mobile-sticky-bar-height",
          `${stickyBar.offsetHeight}px`
        );
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty(
          "--mobile-sticky-bar-height",
          `${stickyBar.offsetHeight}px`
        );
      });
    }
  }

  initMobileAccordion(accordionEl) {
    if (!accordionEl || !window.MinimogLibs || !MinimogLibs.Accordion) return;

    // Allow re-init after breakpoint changes / late idle load
    accordionEl.classList.remove("acc-initialized");

    this.acc = new MinimogLibs.Accordion(accordionEl, {
      presetContentHeight: true,
      onload: false,
    });

    this.refreshAccordionHeight();
  }

  refreshAccordionHeight() {
    const run = () => {
      if (this.acc && typeof this.acc.setContentHeight === "function") {
        this.acc.setContentHeight();
      }
    };

    // Double rAF: wait for layout after idle inject
    requestAnimationFrame(() => requestAnimationFrame(run));

    // Fonts can change scrollHeight after first paint
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run).catch(() => {});
    }

    // Final pass if load is still pending; no-op if already complete
    if (document.readyState !== "complete") {
      window.addEventListener("load", run, { once: true });
    } else {
      setTimeout(run, 100);
    }
  }
}

customElements.define("m-footer", MFooter);
